/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePtTestLandingPageFragment} from '@amblique/contentful/app/contentful/fragments/pt-test-landing-page/base-pt-test-landing-page.fragment';
import {BaseSeoFragment} from '@amblique/contentful/app/contentful/fragments/seo/base-seo.fragment';

export const PtTestLandingPageFragment = gql`
  ${BasePtTestLandingPageFragment}
  ${BaseSeoFragment}

  fragment PtTestLandingPageFragment on PtTestLandingPage {
    ...BasePtTestLandingPageFragment

    seoMetadata {
      ...BaseSeoFragment
    }
  }
`;
